<div class="col-sm-11 center-block">
    <div class="row">
        <div class="col-sm-12">
            <h1>Unauthorized</h1>
            <h2 class="text-danger">You have no rights to access the application. Click <a [routerLink]='["../home"]' href="#">here</a> to route to signin page.</h2>
        </div>
    </div>
</div>
